import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@schibsted-svp/react-ui';

import { ContainerHeader } from '../Container/ContainerHeader/ContainerHeader';
import { CenteredSpinner } from '../CenteredSpinner/CenteredSpinner';
import { Input } from '../Form/Input/Input';
import { SubmitButton } from '../Form/SubmitButton/SubmitButton';
import { Form } from '../Form/Form';
import { ImageUploadInput } from '../Form/ImageUploadInput/ImageUploadInput';

import type { SvpCategory } from '../../types';

type Props = {
  category: SvpCategory;
  onSubmit: (values: SvpCategory) => Promise<void>;
  isLoading?: boolean;
};

function CategoryForm({ category, onSubmit, isLoading = false }: Props) {
  return (
    <Form initialValues={category} onSubmit={onSubmit}>
      <ContainerHeader>
        <Link to="/categories">
          <Button type="button" variant="standard">
            Back
          </Button>
        </Link>
      </ContainerHeader>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <Fragment>
          <Input
            name="title"
            label="Category title"
            disabled
            value={category.title}
          />
          <ImageUploadInput
            name="additional.metadata.verticalPoster.value"
            label="Vertical poster image"
            aspectRatio={2 / 3}
          />
        </Fragment>
      )}
      <SubmitButton>Save</SubmitButton>
    </Form>
  );
}

export { CategoryForm };
